import React from "react"

import styles from "./list-features.module.css"

export default function ListFeatures({ children }) {
  return <div className={styles.listFeatures}>{children}</div>
}
